import { Box, Button, Modal, Typography } from "@mui/material";
import React from "react";
import { ButtonLoader } from "../../inputs.styled";

const DeleteBusinessBoxModal = ({
  open,
  onClose,
  message,
  secondaryButtonText,
  primaryButtonText,
  handleSubmit,
  isLoading,
}) => {
  const styleMod = {
    width: "350px",
    // height: "103px",
    background: "white",
    border: "1px solid var(--Secondary-Blue, #123051)",
    borderRadius: "7px",
    boxShadow: 24,
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    gap: "15px",
    position: "fixed",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    minHeight: "130px",
    maxHeight: "fit-content",
    padding: "24px",
    boxSizing: "border-box",
    outline: "none",

    "&:focus-visible": {
      outline: "none",
    },
  };

  return (
    <Modal
      open={open}
      onClose={onClose}
      BackdropProps={{
        style: {
          backgroundColor: "#F6F7F9",
          opacity: 0.8,
        },
      }}
    >
      <Box sx={styleMod}>
        <Typography
          sx={{
            width: "100%",
            textAlign: "center",
            color: "#000",
            fontSize: "12px",
            fontFamily: "DM Sans",
            fontWeight: "400",
            wordWrap: "break-word",
          }}
        >
          {message}
        </Typography>

        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            gap: "6px",
            marginTop: "10px",
          }}
        >
          {secondaryButtonText && (
            <Button
              variant="outlined"
              sx={{
                textAlign: "center !important",
                color: "#123051 !important",
                fontSize: "8px !important",
                fontFamily: "DM Sans !important",
                fontWeight: "400 !important",
                wordWrap: "break-word !important",
                padding: "6px 20px !important",
                background: "#e1e1e1 !important",
                borderRadius: "20px !important",
                overflow: "hidden !important",
                border: "1px solid #123051 !important",
              }}
              onClick={onClose}
            >
              {secondaryButtonText}
            </Button>
          )}
          <Button
            variant="contained"
            sx={{
              textAlign: "center !important",
              color: "#FFFFFF !important",
              fontSize: "8px !important",
              fontFamily: "DM Sans !important",
              fontWeight: "400 !important",
              wordWrap: "break-word !important",
              padding: "6px 20px !important",
              background: "#123051 !important",
              borderRadius: "20px !important",
              overflow: "hidden !important",

              "&:hover": {
                background: "#c63213 !important",
              },
            }}
            onClick={handleSubmit}
          >
            {isLoading && <ButtonLoader />} {primaryButtonText}
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default DeleteBusinessBoxModal;
